module.exports = __webpack_public_path__ + "img/QRIS.39e1568b.svg";